import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers';
import store from '../../../store/store';
import { BaseComponent } from '../../base-component/base-component';
import { StoreState } from '../../../store/store.interface';
import { getQueryParam } from '../../../common/utils/util';
import { fetchSchoolByXid } from '../../user-profile/thunks/get-school-by-xid.thunk';
import { getSchoolByIdResponse, getSchoolByIdStatus } from '../../user-profile/user-profile.selectors';
import { ActionStatus } from '../../../common/constants/action-status';

/**
 * Component to display the filter used to search for Representatives.
 * It shows the search term based on the selected school or zipcode.
 * It also displays a message when there are no results found.
 */
@customElement('mhecomm-representative-search-results')
export class RepresentativeSearchResults extends connect(store)(BaseComponent) {

  /**
   * Indicates the number of results.
   */
  @property()
  totalResultsCount: number = 0;

  @state()
  private zipcode: string = '';

  @state()
  private schoolName: string = '';

  protected firstUpdated(_changedProperties: Map<string | number | symbol, unknown>) {
    super.firstUpdated(_changedProperties);
    this.zipcode = getQueryParam('zipcode') ?? '';
    const schoolId = getQueryParam('schoolId') ?? '';
    if (schoolId) {
      store.dispatch(fetchSchoolByXid(schoolId));
    }
  }

  stateChanged(state: StoreState) {
    if (getSchoolByIdStatus(state) === ActionStatus.succeeded) {
      this.schoolName = getSchoolByIdResponse(state)[0].name ?? '';
    }
  }

  renderComp() {
    return html`
      <div class="row">
        <div class="row">
          <div class="col-12">
            <h5 class=fw-bold>${this.getSearchType()} Search Results</h5>
          </div>
        </div>
        <div class="row mb-1">
          <p>${this.totalResultsCount} total results for "<strong class="text-capitalize">${this.getSearchTerm().toLowerCase()}</strong>"</p>
        </div>
      </div>
    `;
  }

  private getSearchType(): string {
    return this.schoolName && 'School' || this.zipcode && 'Zip Code' || '';
  }

  private getSearchTerm(): string {
    return this.schoolName || this.zipcode || '';
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-representative-search-results': RepresentativeSearchResults;
  }
}
